define([
    "./monitoringIntegrationModule",
    "text!./nlgMonitoringIntegrationUrlConfiguration.html",
], function (module, template) {

    return module.directive("nlgMonitoringIntegrationUrlConfiguration", [function () {
        return {
            restrict: "E",
            template: template,
            controller: ["$scope", "monitoringIntegrationService", "loadingService", "remoteExceptionHandler", "messagesModal", function ($scope, monitoringIntegrationService, loadingService, remoteExceptionHandler, messagesModal) {
                $scope.model = {};
                loadingService(monitoringIntegrationService.findDefault())
                    .then(config => $scope.model = config)
                    .catch(remoteExceptionHandler());

                $scope.save = () => loadingService(monitoringIntegrationService.save($scope.model))
                    .catch(remoteExceptionHandler())
                    .then(config => $scope.model = config)
                    .then(() => messagesModal("dialog.success", ["lgpd.edition.save.success"]));
            }]
        }
    }])
});